import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsFloatValidator {
  constructor({ value }) {
    this.pattern = '' // TODO сделать регулярку на дробное число
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_float_value" />
  }

  validate() {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(parseFloat(this.value))) {
      return this.errorMessage
    }

    return null
  }
}
